module.exports = {
  debug: process.env.NODE_ENV === 'development',
  i18n: {
    defaultLocale: 'vi',
    locales: ['vi', 'en', 'zh'],
  },
}
